import React from 'react'
import styled from '@emotion/styled'
import {PrimaryOffer} from 'components/Offer/Primary'
import {SecondaryOffer} from 'components/Offer/Secondary'
import {useOtaMode} from 'hooks/useOtaMode'
import {getHighestVisiblePrice} from 'utils/offers'

import {Divider} from '@vio/atlas/Divider'
import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {SelectedBanner} from './SelectedBanner'

interface Props {
  offers: SearchOffer[]
  sourceComponent: string
  hotelId: string
}

const OffersWrapper = styled.div`
  margin: 0 ${minus(cssTheme.layout.spacing.s400)};
`

const PrimaryOfferWrapper = styled.div`
  padding-top: ${cssTheme.layout.spacing.s300};
  padding-right: ${cssTheme.layout.spacing.s400};
  padding-left: ${cssTheme.layout.spacing.s400};
  padding-bottom: ${cssTheme.layout.spacing.s400};
`

export const OffersList = ({offers, sourceComponent, hotelId}: Props) => {
  const {isOTAMode} = useOtaMode()
  const highestPrice = getHighestVisiblePrice(undefined, offers, false)
  const anchorPrice =
    highestPrice === offers[0].nightlyRate ? undefined : highestPrice

  return (
    <OffersWrapper>
      <SelectedBanner />
      <PrimaryOfferWrapper data-id="PrimaryOffer">
        <PrimaryOffer
          variant="PrimaryMultiColumn"
          hotelId={hotelId}
          offer={offers[0]}
          anchorPriceTotal={anchorPrice}
          anchorPrice={anchorPrice}
          hasInteraction
          sourceComponent={sourceComponent}
          showProviderLogo={!isOTAMode}
        />
      </PrimaryOfferWrapper>

      {offers.slice(1, 3).map((offer, index) => (
        <div key={offer.id}>
          <Divider sideMargin="s400" />
          <SecondaryOffer
            variant="SecondaryDefault"
            hotelId={hotelId}
            offer={offer}
            anchorPrice={anchorPrice}
            anchorPriceTotal={anchorPrice}
            hasInteraction
            sourceComponent={sourceComponent}
            offerPosition={index + 1}
            showProviderLogo={!isOTAMode}
          />
        </div>
      ))}
    </OffersWrapper>
  )
}
